module.exports = __webpack_public_path__ + "img/4_102.b94fd089.png";